import type { AppState, Payload } from 'store/state';

export function setDataAction(state: AppState, payload: Payload): AppState {
	return {
		...state,
		data: {
			...state.data,
			...payload.data
		}
	};
}
